import axios from "axios"
import { API_URL } from "./config"
import reduxstore from "../redux/store";
import { loginAction } from "../redux/actions/actions";



const TOKEN = async () => {
    try {
        await axios.get(`${API_URL}/user/get-token`)
            .then(res => {
                console.log("TOKEN");
                console.log(res);
            })

    } catch (error) {
        console.log(error);
        alert("error")
    }
}


const LOGIN_USER_DATA = async () => {
    try {
        return await axios.get(`${API_URL}/user/get-login-user`)
            .then(res => {
                reduxstore.dispatch(loginAction(res.data.user))
                return res.data;
            })

    } catch (error) {
        console.log(error);
        alert(error.response.data.message)
    }
}


const SIGN_UP = async (body) => {
    try {
        axios.defaults.withCredentials = true
        const data = await axios.post(`${API_URL}/user/sign-up`, body)
            .then(res => {
                console.log(res);
                return (res.data)
            })
        return data;
    } catch (error) {
        console.log(error);
        alert(error.response.data.message)
    }
}


const SIGN_IN = async (body) => {
    try {

        const data = await axios.post(`${API_URL}/user/sign-in`, body)
            .then(res => {
                console.log(res);
                return (res.data)
            })

        return data;

    } catch (error) {
        console.log(error);
        alert(error.response.data.message)

    }
}


const SIGN_OUT = () => {
    try {
        const data = axios.get(`${API_URL}/user/signout`)
            .then(res => {
                console.log("logout");
                console.log(res);
                return (res.data)
            })

        return data;

    } catch (error) {
        console.log(error);
        alert(error.response.data.message)
    }
}


const BECOME_A_SELLER = async (body) => {
    try {
        const data = await axios.post(`${API_URL}/request/become_a_seller`, body)
            .then(res => {
                console.log(res);
                return (res.data)
            })
        return data
    }
    catch (e) {
        console.log(e);
        alert(e.response.data.message)
    }
}


const UPLOAD_PROFILE_PIC = async (body) => {
    try {
        const data = await axios.post(`${API_URL}/user/profilePic`, body)
            .then(res => {
                console.log("res", res.data);
                return (res.data)
            })
        return data
    }
    catch (e) {
        console.log(e);
        alert(e.response.data.message)
    }
}


const IMAGEUPLOAD = async (body) => {
    try {
        const data = await axios.post(`${API_URL}/fileUpload`, body)
            .then(res => {
                console.log("res", res.data);
                return (res.data)
            })
        return data
    }
    catch (e) {
        console.log(e);
        alert(e.response.data.message)
    }
}


const GET_ENERGY = async (body) => {
    try {
        const data = await axios.get(`${API_URL}/energy/get_energy`, body)
            .then(res => {
                console.log(res);
                return (res.data)
            })
        return data
    }
    catch (e) {
        console.log(e);
        alert(e.response.data.message)
    }
}


const getSingleEnergy = async (body) => {
    try {
        const data = await axios.post(`${API_URL}/energy/get_single_energy`, body)
            .then(res => {
                console.log(res);
                return (res.data)
            })
        return data
    }
    catch (e) {
        console.log(e);
        alert(e.response.data.message)
    }
}


const BUY_ENERGY = async (body) => {
    try {
        axios.defaults.withCredentials = true

        const data = await axios.post(`${API_URL}/energy/buy_energy`, body)
            .then(res => {
                console.log(res);
                return (res.data)
            })
        return data
    }
    catch (e) {
        console.log(e);
        alert(e.response.data.message)
    }
}


const GET_TX = async (body) => {
    try {
        axios.defaults.withCredentials = true

        const data = await axios.get(`${API_URL}/tx/get_transactions`, body)
            .then(res => {
                console.log(res);
                return (res.data)
            })
        return data
    }
    catch (e) {
        console.log(e);
        // alert(e.response.data.message)
    }
}



const GET_MATIC_AMMOUNT = async () => {
    try {
        axios.defaults.withCredentials = true

        const data = await axios.get(`https://api.coingecko.com/api/v3/simple/price?ids=matic-network&vs_currencies=usd`)
            .then(res => {
                console.log(res);
                return (res.data)
            })
        return data
    }
    catch (e) {
        console.log(e);
        // alert(e.response.data.message)
    }
}



const ADD_WALLET = async (body) => {
    try {
        axios.defaults.withCredentials = true

        const data = await axios.post(`${API_URL}/user/add-wallet`, body)
            .then(res => {
                console.log(res);
                if (res.data.success) {
                    alert("added")
                }
                return (res.data)
            })
        return data
    }
    catch (e) {
        console.log(e);
        // alert(e.response.data.message)

        alert(e.response.data.message)
    }
}


const DELETE_WALLET = async (params) => {
    try {
        axios.defaults.withCredentials = true

        const data = await axios.delete(`${API_URL}/user/delete-wallet/${params}`)
            .then(res => {
                console.log(res);
                return (res.data)
            })
        return data
    }
    catch (e) {
        console.log(e);
        // alert(e.response.data.message)
    }
}


const GET_WALLETS = async (body) => {
    try {
        axios.defaults.withCredentials = true

        const data = await axios.get(`${API_URL}/user/get-wallet`, body)
            .then(res => {
                console.log(res);
                return (res.data)
            })
        return data
    }
    catch (e) {
        console.log(e);
        // alert(e.response.data.message)
    }
}


const ADD_ENERGY = async (body) => {
    try {
        axios.defaults.withCredentials = true

        const data = await axios.post(`${API_URL}/energy/add_energy`, body)
            .then(res => {
                console.log(res);
                return (res.data)
            })
        return data
    }
    catch (e) {
        console.log(e);
        // alert(e.response.data.message)
    }
}


const GET_ALL_SELLERS = async () => {
    try {
        axios.defaults.withCredentials = true

        const data = await axios.get(`${API_URL}/admin/get_all_request`)
            .then(res => {
                console.log(res);
                return (res.data)
            })
        return data
    }
    catch (e) {
        console.log(e);
        // alert(e.response.data.message)
    }
}


const ADMIN_ACTION = async (body) => {
    try {
        axios.defaults.withCredentials = true

        const data = await axios.post(`${API_URL}/admin/adminAction_request`, body)
            .then(res => {
                console.log(res);
                return (res.data)
            })
        return data
    }
    catch (e) {
        console.log(e);
        // alert(e.response.data.message)
    }
}


const UPD_PROFILE = async (body) => {
    try {
        axios.defaults.withCredentials = true
        const data = await axios.post(`${API_URL}/user/update_profile`, body)
            .then(res => {
                console.log(res);
                alert(res.data.message)
                LOGIN_USER_DATA()
                return (res.data)
            })
        return data
    }
    catch (error) {
        console.log(error);
        alert(error.response.data.message)
    }
}


const UPD_PASSWORD = async (body) => {
    try {
        axios.defaults.withCredentials = true
        const data = await axios.post(`${API_URL}/user/update_password`, body)
            .then(res => {
                console.log(res);
                return (res.data)
            })
        return data
    }
    catch (e) {
        alert(e.response.data.message)
        console.log(e);
    }
}


const GET_NOTIFICATIONS = async () => {
    try {
        axios.defaults.withCredentials = true
        const data = await axios.get(`${API_URL}/user/get-notifications`)
            .then(res => {
                console.log(res);
                return (res.data)
            })
        return data
    }
    catch (e) {
        console.log(e);
    }
}


const SEEN_NOTIFICATIONS = async (body) => {
    try {
        axios.defaults.withCredentials = true
        const data = await axios.post(`${API_URL}/user/seen-notifications`, body)
            .then(res => {
                console.log(res);
                return (res.data)
            })
        return data
    }
    catch (e) {
        console.log(e);
    }
}


const SEEN_NOTIFICATIONS_ALL = async (body) => {
    try {
        axios.defaults.withCredentials = true
        const data = await axios.get(`${API_URL}/user/seen-notifications-all`)
            .then(res => {
                console.log(res);
                return (res.data)
            })
        return data
    }
    catch (e) {
        console.log(e);
    }
}


const FORGET_PASS = async (body) => {
    try {
        axios.defaults.withCredentials = true
        const data = await axios.post(`${API_URL}/user/forget_password`, body)
            .then(res => {
                console.log(res);
                return (res.data)
            })
        return data
    }
    catch (e) {
        alert(e.response.data.message)
        console.log(e);
    }
}


const RESET_PASS = async (body, token) => {
    try {
        axios.defaults.withCredentials = true
        const data = await axios.post(`${API_URL}/user/reset_password/${token}`, body)
            .then(res => {
                console.log(res);
                return (res.data)
            })
        return data
    }
    catch (e) {
        alert(e.response.data.message)
        console.log(e);
    }
}


const FILTERS = async (body) => {
    try {
        axios.defaults.withCredentials = true
        const data = await axios.post(`${API_URL}/user/filters`, body)
            .then(res => {
                console.log(res);
                return (res.data)
            })
        return data
    }
    catch (e) {
        console.log(e);
    }
}


const GET_ENERGY_USER = async (body) => {
    try {
        axios.defaults.withCredentials = true
        const data = await axios.get(`${API_URL}/energy/get_energy_user`, body)
            .then(res => {
                console.log(res);
                return (res.data)
            })
        return data
    }
    catch (e) {
        console.log(e);
    }
}


const GET_ENERGY_LOGS = async (body) => {
    try {
        axios.defaults.withCredentials = true
        const data = await axios.get(`${API_URL}/energy/get_energylogs`, body)
            .then(res => {
                console.log(res);
                return (res.data)
            })
        return data
    }
    catch (e) {
        console.log(e);
    }
}


const UPDATE_ENERGY = async (body) => {
    try {
        axios.defaults.withCredentials = true
        const data = await axios.post(`${API_URL}/energy/update-energy`, body)
            .then(res => {
                console.log(res);
                return (res.data)
            })
        return data
    }
    catch (e) {
        console.log(e);
    }
}


const STOP_ENERGY = async (body) => {
    try {
        axios.defaults.withCredentials = true
        const data = await axios.post(`${API_URL}/energy/stop_energy`, body)
            .then(res => {
                console.log(res);
                return (res.data)
            })
        return data
    }
    catch (e) {
        console.log(e);
    }
}


const GET_TOTALENERGY_USER = async (body) => {
    try {
        axios.defaults.withCredentials = true
        const data = await axios.get(`${API_URL}/energy/total_energy_user`, body)
            .then(res => {
                console.log(res);
                return (res.data)
            })
        return data
    }
    catch (e) {
        console.log(e);
    }
}


const SEARCH_SELLER = async (body) => {
    try {
        axios.defaults.withCredentials = true
        const data = await axios.post(`${API_URL}/user/search_seller`, body)
            .then(res => {
                console.log(res);
                return (res.data)
            })
        return data
    }
    catch (e) {
        console.log(e);
    }
}


const AUTOPURCHASE_TOGGLE = async (body) => {
    try {
        axios.defaults.withCredentials = true
        const data = await axios.post(`${API_URL}/user/autopurchaseToggle`, body)
            .then(res => {
                console.log(res);
                LOGIN_USER_DATA()
                return (res.data)
            })
        return data
    }
    catch (e) {
        console.log(e);
    }
}


const AUTOPURCHASE_DATA = async (body) => {
    try {
        axios.defaults.withCredentials = true
        const data = await axios.post(`${API_URL}/user/autopurchaseData`, body)
            .then(res => {
                console.log(res);
                alert(res.data.message)
                LOGIN_USER_DATA()
                return (res.data)
            })
        return data
    }
    catch (e) {
        console.log(e);
    }
}

const ADD_FAV = async (body) => {
    try {
        axios.defaults.withCredentials = true
        const data = await axios.post(`${API_URL}/user/add-favourites`, body)
            .then(res => {
                console.log(res);
                return (res.data)
            })
        return data
    }
    catch (e) {
        console.log(e);

        alert(e.response.data.message)
    }
}



const DEL_FAV = async (body) => {
    try {
        axios.defaults.withCredentials = true
        const data = await axios.post(`${API_URL}/user/delete-favourites`, body)
            .then(res => {
                console.log(res);
                return (res.data)
            })
        return data
    }
    catch (e) {
        console.log(e);

        alert(e.response.data.message)
    }
}




const GET_FAV = async (body) => {
    try {
        axios.defaults.withCredentials = true
        const data = await axios.get(`${API_URL}/user/get-favourites-user`, body)
            .then(res => {
                console.log(res);
                return (res.data)
            })
        return data
    }
    catch (e) {
        console.log(e);
    }
}

const NEEDLE = async () => {
    try {
        axios.defaults.withCredentials = true
        const data = await axios.get(`${API_URL}/energy/energy_percent`)
            .then(res => {
                console.log(res);
                return (res.data)
            })
        return data
    }
    catch (e) {
        console.log(e);
    }
}

const FAV_ENERGY = async () => {
    try {
        axios.defaults.withCredentials = true
        const data = await axios.get(`${API_URL}/user/get-favourites-energy`)
            .then(res => {
                console.log(res);
                return (res.data)
            })
        return data
    }
    catch (e) {
        console.log(e);
    }
}


const AUTOPURCHASE = async (body) => {
    try {
        axios.defaults.withCredentials = true
        const data = await axios.post(`${API_URL}/user/autopurchase`, body)
            .then(res => {
                console.log(res);
                return (res.data)
            })
        return data
    }
    catch (e) {
        console.log(e);
    }
}




const LOCATION_FILTER = async (body) => {
    try {
        axios.defaults.withCredentials = true
        const data = await axios.post(`${API_URL}/user/location_filters`, body)
            .then(res => {
                console.log(res);
                return (res.data)
            })
        return data
    }
    catch (e) {
        console.log(e);
    }
}


const PIE_CHART = async (body) => {
    try {
        axios.defaults.withCredentials = true
        const data = await axios.get(`${API_URL}/tx/get_piChart`)
            .then(res => {
                console.log(res);
                return (res.data)
            })
        return data
    }
    catch (e) {
        console.log(e);
    }
}


const usagePrediction = async (body) => {

    try {
        axios.defaults.withCredentials = true
        const data = await axios.get(`${API_URL}/tx/usage_prediction`)
            .then(res => {
                console.log(res);
                return (res.data)
            })
        return data
    }
    catch (e) {
        console.log(e);
    }
}



const monthlyUsage = async (body) => {

    try {
        axios.defaults.withCredentials = true
        const data = await axios.get(`${API_URL}/tx/monthly_usage`)
            .then(res => {
                console.log(res);
                return (res.data)
            })
        return data
    }
    catch (e) {
        console.log(e);
    }
}


const purchaseVSsold = async (body) => {
    try {
        axios.defaults.withCredentials = true
        const data = await axios.get(`${API_URL}/tx/PurchaseVsSold`)
            .then(res => {
                console.log(res);
                return (res.data)
            })
        return data
    }
    catch (e) {
        console.log(e);
    }
}



const twomonthusage = async (body) => {
    try {
        axios.defaults.withCredentials = true
        const data = await axios.get(`${API_URL}/tx/two_monthly_usage`)
            .then(res => {
                console.log(res);
                return (res.data)
            })
        return data
    }
    catch (e) {
        console.log(e);
    }
}



const twomonthusagePercentage = async (body) => {
    try {
        axios.defaults.withCredentials = true
        const data = await axios.get(`${API_URL}/tx/two_monthly_usage_percentage`)
            .then(res => {
                console.log(res);
                return (res.data)
            })
        return data
    }
    catch (e) {
        console.log(e);
    }
}

export {
    usagePrediction,
    twomonthusage,
    twomonthusagePercentage,
    purchaseVSsold,
    monthlyUsage,
    TOKEN,
    PIE_CHART,
    LOCATION_FILTER,
    NEEDLE,
    AUTOPURCHASE,
    GET_FAV,
    FAV_ENERGY,
    DEL_FAV,
    ADD_FAV,
    SIGN_UP,
    SIGN_IN,
    SIGN_OUT,
    STOP_ENERGY,
    AUTOPURCHASE_DATA,
    AUTOPURCHASE_TOGGLE,
    GET_TOTALENERGY_USER,
    UPDATE_ENERGY,
    FILTERS,
    SEARCH_SELLER,
    FORGET_PASS,
    GET_ENERGY_LOGS,
    GET_MATIC_AMMOUNT,
    GET_ENERGY_USER,
    RESET_PASS,
    GET_NOTIFICATIONS,
    GET_ALL_SELLERS,
    UPD_PASSWORD,
    SEEN_NOTIFICATIONS,
    ADD_ENERGY,
    UPD_PROFILE,
    ADMIN_ACTION,
    SEEN_NOTIFICATIONS_ALL,
    BECOME_A_SELLER,
    IMAGEUPLOAD,
    getSingleEnergy,
    GET_ENERGY,
    BUY_ENERGY,
    GET_TX,
    ADD_WALLET,
    GET_WALLETS,
    DELETE_WALLET,
    LOGIN_USER_DATA,
    UPLOAD_PROFILE_PIC
}